<template>
  <div>
    <v-row>
    </v-row>
  </div>
</template>

<script>
import {LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";

export default {
  name: "RevizorDashboardPage",
  computed: { },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('revizorDashboard.pageTitle'))
  }
}
</script>

<style scoped>

</style>